/**
 * Blog Highlights Slider
 * Initializes Slick slider for blog articles on mobile devices
 */

(function () {
  'use strict';

  var SLICK_RETRY_DELAY_MS = 100;
  var SLICK_MAX_RETRIES = 50;

  function initBlogHighlightsSlider(attempt) {
    attempt = attempt || 0;

    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      if (attempt >= SLICK_MAX_RETRIES) {
        return;
      }
      setTimeout(function () {
        initBlogHighlightsSlider(attempt + 1);
      }, SLICK_RETRY_DELAY_MS);
      return;
    }

    const $slider = jQuery('.js-blog-highlights-slider');

    if ($slider.length === 0) {
      return;
    }

    // Only initialize slider on mobile devices
    function initSlider() {
      if (window.innerWidth < 768) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
          });
        }
      } else {
        // Destroy slider on desktop
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    // Initialize on load
    initSlider();

    // Re-initialize on resize (with debounce)
    let resizeTimer;
    jQuery(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initSlider();
      }, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogHighlightsSlider);
  } else {
    initBlogHighlightsSlider();
  }
})();
